import { styled } from '../../../configs/stitches.config';

export const FooterContainer = styled('section', {
  alignItems: 'center',
  backgroundColor: '$backgroundPrimary',
  display: 'flex',
  gap: '0.375rem',
  justifyContent: 'center',
  paddingLeft: '$spacingXl',
  paddingRight: '$spacingXl',
  width: '100%',
});

export const FooterDivider = styled('div', {
  height: '3rem',
  lineHeight: '2.5rem',
});

export const LinkCopy = styled('p', {
  font: '$captionRegular',
});
